import React from 'react';
import PropTypes from 'prop-types';

export const SvgBriefcase = ({ width, height }) => (
  <svg width={width || '16px'} height={height || '14px'} viewBox="0 0 16 14" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-148.000000, -292.000000)" stroke="#000000" strokeWidth="2">
        <g transform="translate(144.000000, 287.000000)">
          <rect x="5.33333333" y="8.66666667" width="13.3333333" height="9.33333333" rx="2" />
          <path d="M14.6666667,18 L14.6666667,7.33333333 C14.6666667,6.59695367 14.069713,6 13.3333333,6 L10.6666667,6 C9.930287,6 9.33333333,6.59695367 9.33333333,7.33333333 L9.33333333,18" />
        </g>
      </g>
    </g>
  </svg>
);

SvgBriefcase.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};
